import React, { useState } from "react";
import { FaBars, FaShoppingCart } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardDropdown from "../AdminDropdown/DasboardDropdown";
// import LanguageDropdown from "../AdminDropdown/LanguageDropdown";
import axios from "axios";
import { apiKey } from "../../config/config";
import { TfiReload } from "react-icons/tfi";
import { FaLanguage, FaTablet } from "react-icons/fa6";
import { languageHelper } from "../../config/helperFunctions";

export default function Navbar({ toggleModal, handleLangChange }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);

  const navigate = useNavigate();

  const handleReload = () => {
    window.location.reload();
  };

  const handleShift = () => {
    axios
      .get(`${apiKey}/api/rms/admin/verifyShift`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toggleModal(true);
      })
      .catch((err) => {
        navigate("openRegister");
      });
  };

  return (
    <header>
      {/* Navbar */}
      <nav className="relative shadow-lg bg-[#fff] md:flex-row md:flex-nowrap md:justify-start flex items-center py-4 px-2 w-full rounded-md">
        <div className="w-full mx-auto gap-4 items-center flex justify-between md:flex-nowrap flex-wrap md:px-4 px-2">
          {/* Toggle button for sidebar */}
          <button
            className="lg:hidden text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <FaBars />
          </button>
          {/* Navigation links (hidden on small screens) */}
          <div className="hidden lg:flex gap-4">
            <NavLink to="/POS/main" className="flex gap-1 items-center group">
              <FaTablet className=" fill-[#6f6b7d] group-hover:fill-d-bg-text" />
              <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                {languageHelper(defaultLang, "pos") || "POS"}
              </span>
            </NavLink>
            <NavLink
              to="./purchase/addPurchase"
              className="flex gap-1 items-center group"
            >
              <FaShoppingCart className=" fill-[#6f6b7d] group-hover:fill-d-bg-text" />
              <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                {languageHelper(defaultLang, "add purchase") ||
                  "All Purchases"}
              </span>
            </NavLink>
            <button
              className="flex gap-1 items-center text-[#6f6b7d] uppercase text-sm font-semibold group hover:text-d-bg-text"
              type="button"
              onClick={handleShift}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                </svg>
              </span>
              {languageHelper(defaultLang, "shift open close") ||
                "Shift Open/Close"}
            </button>
          </div>
          <div className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto ">
            <div className="relative flex w-full flex-wrap gap-4 items-stretch">
              {/* <NavLink
                to="watchUser"
                className="flex gap-1 items-center group relative"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z" />
                </svg>
                <span className="hidden group-hover:block w-32 bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  Watch User Guide
                </span>
              </NavLink> */}

              <NavLink
                to="/"
                target="_blank"
                className="flex gap-1 items-center relative group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
                </svg>
                <span className="hidden group-hover:block bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  {languageHelper(defaultLang, "web") || "Website"}
                </span>
              </NavLink>

              <button
                onClick={() => setShowLangDropdown(!showLangDropdown)}
                className="flex gap-1 items-center relative group"
              >
                <FaLanguage className="fill-[#6f6b7d] group-hover:fill-d-bg-text font-semibold" />

                <span className="hidden group-hover:block bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  {languageHelper(defaultLang, "language") ||
                    "Language"}
                </span>

                {showLangDropdown && (
                  <div
                    className={
                      "absolute top-10 left-6 -translate-x-[90%] bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-32 border"
                    }
                  >
                    <div className="text-sm py-2 text-d-bg-text px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
                      <button
                        onClick={() => handleLangChange("text_en")}
                        className="flex gap-2 items-center"
                      >
                        <span className="">English</span>
                      </button>
                    </div>
                    <div className="text-sm py-2 text-d-bg-text px-3 font-semibold block w-full whitespace-nowrap bg-transparent text-blueGray-700">
                      <button
                        onClick={() => handleLangChange("text_ar")}
                        className="flex gap-2 items-center"
                      >
                        <span className="">Arabic</span>
                      </button>
                    </div>
                  </div>
                )}
              </button>

              <button
                onClick={handleReload}
                className="flex gap-1 items-center relative group"
              >
                <TfiReload className="fill-[#6f6b7d] group-hover:fill-d-bg-text font-semibold" />

                <span className="hidden group-hover:block bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  {languageHelper(defaultLang, "reload") || "Reload"}
                </span>
              </button>

              <button to="/" className="flex gap-1 items-center ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] hover:fill-d-bg-text"
                  height="20"
                  width="30"
                >
                  <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
                </svg>
              </button>

              {/* <LanguageDropdown /> */}
              <DashboardDropdown />
            </div>
          </div>
        </div>
      </nav>
      {/* Sidebar (visible on small screens) */}
      <div
        className={`fixed top-0 right-0 h-full z-50 w-64 bg-white shadow-lg transform ${
          sidebarOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        {/* Close button */}
        <div className="flex justify-start p-4">
          <button
            className="text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(false)} // Close sidebar when clicked
          >
            <FaBars />
          </button>
        </div>

        <div className="flex justify-end p-4">
          <button
            className="text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-6 w-6"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav className="flex flex-col gap-4 p-4">
          <NavLink to="/POS/main" className="flex gap-1 items-center group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className=" fill-[#6f6b7d] group-hover:fill-d-bg-text"
              height="16"
              width="18"
            >
              <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
            </svg>
            <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
              {languageHelper(defaultLang, "pos") || "POS"}
            </span>
          </NavLink>
          <NavLink
            to="./purchase/addPurchase"
            className="flex gap-1 items-center group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
              height="16"
              width="18"
            >
              <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
            </svg>
            <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
              {languageHelper(defaultLang, "add purchases") ||
              "All Purchases"}
            </span>
          </NavLink>
          <button
            className="flex gap-1 items-center text-[#6f6b7d] uppercase text-sm font-semibold group hover:text-d-bg-text"
            type="button"
            onClick={() => {
              toggleModal(true);
              setSidebarOpen(false);
              setSidebarOpen(false);
            }}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                height="16"
                width="18"
              >
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
              </svg>
            </span>
            {languageHelper(defaultLang, "shift open close") || "Shift Open/Close"}
          </button>
        </nav>
      </div>
      {/* End Navbar */}
    </header>
  );
}
